export const server = process.env.NODE_ENV === 'development' ? 'http://localhost:1300' : '';
